import { Asterisk } from "lucide-react";

const ITEMS = [
  "7/24 Konya Oto Çekici",
  "Adem Ildırar",
  "0539 219 60 17",
  "İl içi – İl dışı",
  "Kaza kurtarma",
  "Akü takviye",
  "Hızlı ulaşım",
  "Şeffaf fiyat",
];

export default function Marquee() {
  return (
    <div
      data-testid="emergency-marquee"
      className="relative border-y border-brand/25 bg-night-800/70 py-3.5 overflow-hidden"
      aria-label="Konya Çekicim hizmet bandı"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {[0, 1].map((half) => (
          <div key={half} aria-hidden={half === 1} className="flex items-center shrink-0">
            {ITEMS.map((item, i) => (
              <span
                key={`${half}-${item}`}
                className="flex items-center font-display font-semibold uppercase tracking-wider text-lg md:text-xl text-slate-200 whitespace-nowrap"
              >
                <Asterisk className="w-5 h-5 mx-5 text-brand shrink-0" aria-hidden="true" />
                <span className={i === 2 ? "text-brand" : ""}>{item}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
